module.exports = __webpack_public_path__ + "h5/img/base_photo_1.03c14aec.png";